import groupFields from './groupFields/groupFieldsEmail'

export default () => {
  return [groupFields()]
}
